import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCloseComponent } from "./med-icon-close.component";

@NgModule({
  declarations: [
    MedIconCloseComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCloseComponent,
  ],
})
export class MedIconCloseModule { }
